import React, { useState } from 'react';
import SEO from '../components/SEO';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import DatePicker from 'react-datepicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import 'react-datepicker/dist/react-datepicker.css';
import '../styles/DocumentsPage.css';
import SubNav from '../components/subNav';
import { useDocuments } from '../context/DocumentsContext';
import { baseUrl } from '../config';



const DocumentsPage = () => {
  const { documents, addDocument, removeDocument } = useDocuments();
  const [newDocument, setNewDocument] = useState({
    type: '',
    createdAt: new Date(),
    form: null,
    formUrl: null,
  });
  const [filterText, setFilterText] = useState('');
  const [showNewDocumentRow, setShowNewDocumentRow] = useState(false);
  const [sortCriteria, setSortCriteria] = useState('date');
  const navigate = useNavigate(); // Initialize navigate

  const handleAdd = () => {
    if (newDocument.type && newDocument.form) {
      addDocument(newDocument);
      setNewDocument({ type: '', createdAt: new Date(), form: null, formUrl: null });
      setShowNewDocumentRow(false);
    } else {
      alert('Please fill in all fields and upload a document.');
    }
  };

  const handleDelete = (id) => {
    removeDocument(id);
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const url = URL.createObjectURL(file);
      setNewDocument({ ...newDocument, form: file.name, formUrl: url });
    }
  };

  const handleEdit = (id) => {
    navigate(`/edit/${id}`); // Navigate to EditDocumentPage with the document ID
  };

  const filteredDocuments = documents
    .filter((doc) => doc.type.toLowerCase().includes(filterText.toLowerCase()))
    .sort((a, b) => {
      if (sortCriteria === 'date') {
        return new Date(b.createdAt) - new Date(a.createdAt);
      } else if (sortCriteria === 'type') {
        return a.type.localeCompare(b.type);
      }
      return 0;
    });

  return (
    <>
    <SEO
      title="Documents"
      description="View and manage all documents for your film production project on ProducerBuddy."
      url="https://producerbuddy.pilomation.com/documents"
      robots="noindex, nofollow"
    />
    <SubNav/>
    <div>
     
      <div className="documents-page">
        <h2>DOCUMENTS</h2>
        <div className="controls">
          <select value={sortCriteria} onChange={(e) => setSortCriteria(e.target.value)}>
            <option value="date">Sort by Date</option>
            <option value="type">Sort by Type</option>
          </select>
          <input
            type="text"
            placeholder="Filter documents..."
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
          />
          <button className="add-button" onClick={() => setShowNewDocumentRow(true)}>+</button>
        </div>
        <table>
          <thead>
            <tr>
              <th>Type</th>
              <th>Created At</th>
              <th>Form</th>
              <th>Action</th>
              <th>Download</th>
              <th>Edit</th>
            </tr>
          </thead>
          <tbody>
            {filteredDocuments.map((doc) => (
              <tr key={doc.id}>
                <td>{doc.type}</td>
                <td>{new Date(doc.createdAt).toLocaleString()}</td>
                <td><a href="#">{doc.form}</a></td>
                <td>
                  <button onClick={() => handleDelete(doc.id)} className="delete-icon">
                    <FontAwesomeIcon icon={faTrash} />
                  </button>
                </td>
                <td>
                  {doc.formUrl ? (
                    <a href={doc.formUrl} download={doc.form} className="download-button">
                      Download
                    </a>
                  ) : (
                    <span>No file</span>
                  )}
                </td>
                <td>
                  <button onClick={() => handleEdit(doc.id)} className="edit-button">Edit</button>
                </td>
              </tr>
            ))}
            {showNewDocumentRow && (
              <tr>
                <td>
                  <input
                    type="text"
                    placeholder="Document Type"
                    value={newDocument.type}
                    onChange={(e) => setNewDocument({ ...newDocument, type: e.target.value })}
                  />
                </td>
                <td>
                  <DatePicker
                    selected={newDocument.createdAt}
                    onChange={(date) => setNewDocument({ ...newDocument, createdAt: date })}
                    showTimeSelect
                    dateFormat="Pp"
                  />
                </td>
                <td>
                  <input type="file" onChange={handleFileUpload} />
                  {newDocument.form && <span>{newDocument.form}</span>}
                </td>
                <td>
                  <button onClick={handleAdd} className="save-button">Save</button>
                  <button onClick={() => setShowNewDocumentRow(false)} className="cancel-button">Cancel</button>
                </td>
                <td></td>
                <td></td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
    </>
  );
};

export default DocumentsPage;

